module.exports = __webpack_public_path__ + "static/media/chevron-circle-down.2379de07.svg";